import { useEffect } from 'react';

const useTitle = (title?: string) => {
	useEffect(() => {
		const prevTitle = document.title; // Store the original title
		document.title = title ? title + ' | Elephant Expeditions' : 'Elephant Expeditions'; // Set the new title

		// Return a cleanup function to revert the title when the component unmounts
		return () => {
			document.title = prevTitle;
		};
	}, [title]);
};

export default useTitle;
